export function fieldValidator(name, value) {
   let errorMsg = null;

  switch (name) {
    case 'email':
    case 'invoice_email':
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
        errorMsg = 'Helytelen e-mail formátum';
      }
      break;
    case 'invoice_taxcode':
      if (!/^(0|[0-9]{8}-?[0-9]-?[0-9]{2})$/i.test(value)) {
        errorMsg = 'Helytelen adószám formátum';
      }
      break;
    case 'password':
      if (value && value.length < 10) {
        errorMsg = 'A jelszó túl rövid';
      } else {
        const containsNumeric = /[0-9]/.test(value);
        const containsLowerCase = /[a-z]/.test(value);
        const containsUpperCase = /[A-Z]/.test(value);
        if (
          !(containsNumeric && containsLowerCase && containsUpperCase) &&
          value
        ) {
          errorMsg = 'A jelszónak legalább 10 karakter hosszúnak kell lennie, és tartalmaznia kell kisbetűt, nagybetűt és számot.';
        }
      }
      break;
  }

  if (!value || value.length === 0) {
    errorMsg = 'Kötelező mező';
  }

  return errorMsg;
};
